import { useMutation } from 'react-query';
import { testCustomSMTPSender, TestCustomSMTPSenderParams } from '../../api';

export function useTestCustomSMTPSender() {
  return useMutation(
    (variables: TestCustomSMTPSenderParams) => testCustomSMTPSender(variables),
    {},
  );
}
